// WHO IS WAITING TO HEAR FROM ME TODAY — the lead follow-ups whose date has arrived.
//
// ITS OWN SECTION, NEVER MERGED WITH THE TASKS. A task is something to produce; following
// up a lead is contact tracking — we spoke, this is what was agreed, get back to them on
// the 24th. They carry different fields and are said in different words, and the server
// sends them as siblings for exactly this reason (see calculations/leadFollowUps). One
// mixed list would need a `kind` on every row to tell apart two things that were never
// one.
//
// WHAT THEY DO SHARE is the date rule — both rows arrive with `due_state` already judged
// by calculations/dueState — so the two sections split late from today identically.
//
// Always to /leads: a follow-up lives on the lead and there is nowhere else it could
// sensibly take you. No board question, and no orphan case — a follow-up on a lost or
// won lead is not due at all.
import he from '../../i18n/he';
import DateText from '../../components/DateText';
import DayRow from './DayRow';
import { DayGroup } from './DaySection';

const LeadRow = ({ row }) => (
  <DayRow
    to="/leads"
    late={row.due_state === 'overdue'}
    color={row.client.color}
    name={row.client.name}
    date={row.follow_up_on}
    go={he.myDay.goLead}
    foot={<span className="muted">{[row.contact_name, row.owner_name].filter(Boolean).join(' · ')}</span>}
  >
    {/* WHAT WAS AGREED, read off the last logged conversation — the useful thing at the
        moment you are about to pick up the phone, and the whole reason the notes
        accumulate instead of being one overwritten field. */}
    <span className="day-row-text">
      {row.last_note
        ? <>{he.myDay.lastContact} <DateText value={row.last_contacted_on} />: {row.last_note}</>
        : <span className="muted">{he.myDay.noContactYet}</span>}
    </span>
  </DayRow>
);

export default function DayLeads({ rows }) {
  const late = rows.filter((r) => r.due_state === 'overdue');
  const today = rows.filter((r) => r.due_state !== 'overdue');

  return (
    <div className="day-groups">
      {late.length > 0 && (
        <DayGroup title={he.myDay.groupLate} late>
          {late.map((row) => <LeadRow key={row.key} row={row} />)}
        </DayGroup>
      )}
      {today.length > 0 && (
        <DayGroup title={he.myDay.groupToday}>
          {today.map((row) => <LeadRow key={row.key} row={row} />)}
        </DayGroup>
      )}
    </div>
  );
}
